export * from './model'
export * from './queryKey'
export * from './mutex'

// Re-export standaloneApi and types from the standalone file (no circular deps)
export { standaloneApi } from './standaloneApi'
export type { ApiGETFn } from './standaloneApi'

// NOTE: useApi is NOT exported from this barrel to avoid SSR circular dependency issues.
// Import useApi directly from: import { useApi } from '@api/useApi.hook'
